import React from 'react';
import { ViewStyle } from 'react-native';

import { IconButton } from './icon-button';

import { useTheme } from '@/components/theme-provider';

export interface RefreshButtonProps {
	onPress?: () => void;
	disabled?: boolean;
	size?: number;
	style?: ViewStyle;
	iconColor?: string;
	backgroundColor?: string;
	accessibilityLabel?: string;
	testID?: string;
}

export const RefreshButton: React.FC<RefreshButtonProps> = ({
	onPress,
	disabled = false,
	size = 24,
	style,
	iconColor,
	backgroundColor,
	accessibilityLabel = 'Refresh',
	testID,
}) => {
	const theme = useTheme();

	return (
		<IconButton
			icon="refresh-outline"
			onPress={onPress}
			disabled={disabled}
			size={size}
			style={style}
			iconColor={iconColor || theme.colors.primary}
			backgroundColor={backgroundColor}
			accessibilityLabel={accessibilityLabel}
			testID={testID}
		/>
	);
};
